// 路由拦截器
import watermark from 'watermark-dom'
export default function (router) {
  // 全局守卫
  router.beforeEach(async (to, from, next) => {
    const token = localStorage.getItem("token");
    let permissions = JSON.parse(localStorage.getItem("permissions"))
      ? JSON.parse(localStorage.getItem("permissions"))
      : [].concat(["/"]);
    permissions = permissions.concat(["Login", "404"]);
    // console.log("to.name", to.name);
    if (to.name !== "Login" && !token) {
      //如果要跳转的页面不是登录页面 并且没有token就直接跳转登录页
      next({ name: "Login" });

    } else {
      const username = localStorage.getItem('username');
      const account = localStorage.getItem('account');
      if (username && account) {
        watermark.load({
          watermark_txt: username + ' ' + account,
          // watermark_color: '#999999' //水印字体颜色
          watermark_color: 'rgba(255,255,255,0)' //水印字体颜色
        });
      }

      // // console.log("permissions", permissions);
      if (permissions.includes(to.name)) {
        next();
      } else {
        if (token) {
          if (to.path === "/") {
            next({ name: permissions[0], replace: true });
          } else {
            next({ path: "/404", replace: true });
          }
        } else {
          next();
        }
      }
    }
  });
}
